/* eslint-disable no-restricted-imports -- File defines overrides */
import type { LinkProps as ExternalLinkProps } from '@opendoor/bricks-next';
import {
  Button as BNButton,
  IconButton as BNIconButton,
  Link as BNLink,
  PressableBox as BNPressableBox,
  TextButton as BNTextButton,
} from '@opendoor/bricks-next';
// eslint-disable-next-line import-x/no-internal-modules -- needed for abstractions
import { withCTAHandling, withInternalCTAHandling } from 'platform/router/internal';

import type {
  ButtonProps,
  IconButtonProps,
  LinkProps,
  MarginProps,
  PaddingProps,
  PressableBoxProps,
  ResponsiveProps,
  TextButtonProps,
} from './types';

const InternalLink = withInternalCTAHandling<LinkProps>(BNLink);
const InternalTextButton = withInternalCTAHandling<TextButtonProps>(BNTextButton);
const InternalIconButton = withInternalCTAHandling<IconButtonProps>(BNIconButton);
const InternalButton = withInternalCTAHandling<ButtonProps>(BNButton);
const InternalPressableBox = withInternalCTAHandling<PressableBoxProps>(BNPressableBox);

export const ExternalLink = BNLink;

export const Link = withCTAHandling<LinkProps>(BNLink, InternalLink);
export const TextButton = withCTAHandling<TextButtonProps>(BNTextButton, InternalTextButton);
export const IconButton = withCTAHandling<IconButtonProps>(BNIconButton, InternalIconButton);
export const Button = withCTAHandling<ButtonProps>(BNButton, InternalButton);
export const PressableBox = withCTAHandling<PressableBoxProps>(
  BNPressableBox,
  InternalPressableBox,
);

export type {
  ButtonProps,
  IconButtonProps,
  LinkProps,
  ExternalLinkProps,
  /**
   * @public
   */
  PaddingProps,
  MarginProps,
  PressableBoxProps,
  ResponsiveProps,
};
